<template>
  <v-app>
    <router-view name="navigation"></router-view>
    <v-main>
      <alert-banners></alert-banners>
      <login-window-modal></login-window-modal>
      <on-boarding-welcome-modal v-if="$store.state.ui.displayOnBoardingWelcomeModal"></on-boarding-welcome-modal>
      <premium-suspended></premium-suspended>
      <zoho-chat></zoho-chat>
      <v-container id="vue-main-container" fluid class="pa-0 pa-sm-6 bg-background" style="min-height: calc(100vh - 48px)">
        <router-view :key="$route.path"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
  .mobileview #vue-main-container {
    padding: 0 !important;
  }
</style>

<script>
  import AlertBanners from '@/components/AlertBanners/AlertBanners';
  import LoginWindowModal from '@/components/User/LoginWindowModal';
  import PremiumSuspended from '@/components/Premium/PremiumSuspended';
  import ZohoChat from '@/components/Help/ZohoChat';

  export default {
    components: {
      AlertBanners,
      LoginWindowModal,
      OnBoardingWelcomeModal: () => import(/* webpackChunkName: "onboarding" */ '@/components/OnBoarding/OnBoardingWelcomeModal'),
      PremiumSuspended,
      ZohoChat,
    },
    created() {
      this.$store.state.users.userPromise.then((user) => {
        // new version popup
        if (user.last_visit && moment(user.last_visit).isBefore('2023-10-02') && moment().isBefore('2023-11-18')) {
          this.$store.dispatch('ui/msgbox/open', { title: "HELP.NEW_VERSION_TITLE", body: "HELP.NEW_VERSION", buttons: { ok: "HELP.NEW_VERSION_BUTTON" } });
        }
      });
    },
  };
</script>
